import { useCallback, useMemo, useState } from 'react';
import { createUserPreferenceStore } from '../../../../lib/preferences';
import { useCurrentSession } from '../../../../stores/session';

// DECISIONS-LOG 2026-10-26 "power sorting must keep the table in view": the full Ideal candidate card starts folded, so the focus
// bar and the table are what is on screen. Opening it is remembered per person and per job, as the keywords are.

const OPEN_KEY_PREFIX = 'ranking.icp-card-open.';

interface IcpCardFold {
  readonly isFolded: boolean;
  readonly setFolded: (isFolded: boolean) => void;
}

export function useIcpCardFold(jobId: string): IcpCardFold {
  const userId = useCurrentSession()?.id ?? 'anonymous';
  const store = useMemo(() => createUserPreferenceStore(userId), [userId]);
  const key = `${OPEN_KEY_PREFIX}${jobId}`;
  const [state, setState] = useState(() => ({ key, isOpen: store.get<unknown>(key, false) === true }));
  // Another job's page reuses this component: read its own choice rather than carry this one over.
  const isOpen = state.key === key ? state.isOpen : store.get<unknown>(key, false) === true;
  const setFolded = useCallback(
    (isFolded: boolean): void => {
      setState({ key, isOpen: !isFolded });
      if (isFolded) store.remove(key);
      else store.set(key, true);
    },
    [store, key],
  );
  return { isFolded: !isOpen, setFolded };
}
